import { api } from "./client";
import type { Page } from "./hits";

export interface Operativo {
  id: number;
  clientId: string;
  nombre: string;
  descripcion: string | null;
  objetivos: string | null;
  autoridadId: number;
  rutaId: number | null;
  fase: string;
  programadoInicio: string | null;
  programadoFin: string | null;
  enCursoInicio: string | null;
  hitInicio: string | null;
  aseguramientoInicio: string | null;
  disposicionInicio: string | null;
  cerradoInicio: string | null;
  creadoPor: number;
  cerradoPor: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface OperativoFase {
  id: number;
  faseAnterior: string | null;
  faseNueva: string;
  comentario: string | null;
  usuarioId: number;
  unitId: number | null;
  latitude: number | null;
  longitude: number | null;
  at: string;
}

export async function listOperativos(params: {
  fase?: string;
  page?: number;
  size?: number;
}): Promise<Page<Operativo>> {
  const res = await api.get<Page<Operativo>>("/operativos", { params });
  return res.data;
}

export async function getOperativo(id: number): Promise<Operativo> {
  const res = await api.get<Operativo>(`/operativos/${id}`);
  return res.data;
}

export async function createOperativo(body: {
  nombre: string;
  descripcion?: string;
  objetivos?: string;
  autoridadId: number;
  rutaId?: number;
  programadoInicio?: string;
  programadoFin?: string;
  unitIds?: number[];
}): Promise<Operativo> {
  const res = await api.post<Operativo>("/operativos", body);
  return res.data;
}

export async function transitionFase(
  id: number,
  body: { faseNueva: string; comentario?: string }
): Promise<Operativo> {
  const res = await api.post<Operativo>(`/operativos/${id}/fase`, body);
  return res.data;
}

export async function listFases(id: number): Promise<OperativoFase[]> {
  const res = await api.get<OperativoFase[]>(`/operativos/${id}/fases`);
  return res.data;
}
